export const GET_OPERATORI = 'GET_OPERATORI';

/**
 * Get groups of users
 * @function getGroup
 */
export function getOperatori() {
  return {
    type: GET_OPERATORI,
    request: {
      op: 'get',
      path: `@operatori_pratica`,
    },
  };
}
